<template>
    <div>vgoodslistadd</div>
</template>
<script>
</script>